module.exports = "<router-outlet></router-outlet>\n<ngx-spinner bdColor = \"rgba(51, 51, 51, 0.8)\" size = \"large\" color = \"#fff\" type = \"cube-transition\"></ngx-spinner>\n\n<!-- newsportswebmobplatform-18023153-angular4 \n@ph_suraj_mobiloitte \n ph-suraj@mobiloitte.com-->"


//////////////////
// WEBPACK FOOTER
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main